/**
 * MultiSelect pill — used for sectors, business models.
 * value: array of selected keys
 * options: [{key, label}]
 */
export const MultiSelect = ({ options, value = [], onChange, testId }) => {
  const toggle = (key) => {
    if (value.includes(key)) {
      onChange(value.filter((k) => k !== key));
    } else {
      onChange([...value, key]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {options.map((opt) => {
        const selected = value.includes(opt.key);
        return (
          <button
            type="button"
            key={opt.key}
            onClick={() => toggle(opt.key)}
            aria-pressed={selected}
            className={`wit-pill transition-colors ${
              selected
                ? "bg-raspberry text-white border-raspberry"
                : "bg-white border-sandBeige text-cocoa hover:border-raspberry"
            }`}
            data-testid={`${testId}-${opt.key}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default MultiSelect;
